<template>
  <div class="login">
    <div class="max-w-xl mx-auto ">
      <div class="bg-white md:border md:border-gray-300 md:rounded p-6 mx-1">
        <h1 class='mb-8 text-center'>Reset my password</h1>
        <div class="w-full max-w-md mx-auto">
          <div class="pb-4">
            <div class="mb-6">
              <label class="block text-gray-700 text-sm font-bold mb-2 text-left" for="email">
                Email Address
              </label>
              <input v-model.trim="email" @keyup.enter="resetPassword" class="form-input" id="email" type="text" placeholder="farm.name@email.com">
            </div>
            <div class="flex items-center justify-between">
              <button @click="resetPassword" class="flex-grow btn btn-blue" type="button">
                Reset password
              </button>
            </div>
          </div>
        </div>
      </div>
      <template v-if="showHelpers">
        <div class="flex justify-center mt-6">
          <p class="inline-block align-baseline font-bold text-lg">Nevermind, I remembered!
            <router-link to="/signin" class="link">
              Sign in
            </router-link>
          </p>
        </div>
        <div class="flex justify-center mt-1">
          <p class="inline-block align-baseline font-bold text-lg">Don't have an account?
            <router-link to="/signup" class="link">
              Sign up here.
            </router-link>
          </p>
        </div>
      </template>
    </div>
  </div>
</template>

<script>

export default {
  name: 'login',
  data () {
    return {
      email: ''
    }
  },
  props: {
    showHelpers: {
      type: Boolean,
      default: true
    }
  },
  methods: {
    resetPassword () {
      this.$store.dispatch('forgotPassword', {email: this.email})
        .then(response => {
          this.notie.alert({
            type: 1,
            text: `Password reset link was sent to ${this.email}, please check your email.`
          })
        })
        .catch(error => {
          // this.$honeybadger.notify(error)
          this.notie.alert({
            type: 3,
            text: `${error}<br>You can send an email to <b>${process.env.VUE_APP_SUPPORT_EMAIL}</b> if the error continues.`
          })
        })
    }
  }
}
</script>
